import { Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'eui-header',
    templateUrl: './header.component.html',
    styleUrls: ['./_styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiHeaderComponent {

    @HostBinding('class') string = 'eui-header';

    constructor() {
    }
}
